var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2226 16.6466L8.77076 30.0712L9.43522 31.4137L34.9502 19.6L33.2226 16.6466Z",
    fill: "#F4CD42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4053 44.0329L15.5482 42.2877V44.7041L40 49L38.4053 44.0329Z",
    fill: "#F4CD42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8771 0.805479L2.39203 21.211L0 20.4055L11.5615 0L16.8771 0.805479Z",
    fill: "#F4CD42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkYellow);
export default __webpack_public_path__ + "static/media/spark-yellow.5f14f6d44a34b2ee91e48cc2a6d7e352.svg";
export { ForwardRef as ReactComponent };